const icons = {
  actions: {
    arrowRight: "fas fa-arrow-right",
    bars: "fas fa-bars",
    checkCircle: "fas fa-check-circle",
    chevronDown: "fas fa-chevron-down",
    chevronLeft: "fas fa-chevron-left",
    chevronRight: "fas fa-chevron-right",
    close: "fas fa-times",
    heart: "fas fa-heart",
    paperPlane: "fas fa-paper-plane",
  },

  contact: {
    email: "fas fa-envelope",
    location: "fas fa-map-marker-alt",
    phone: "fas fa-phone",
    whatsapp: "fab fa-whatsapp",
  },

  social: {
    facebook: "fab fa-facebook",
    facebookF: "fab fa-facebook-f",
    instagram: "fab fa-instagram",
    linkedIn: "fab fa-linkedin",
    linkedInIn: "fab fa-linkedin-in",
    twitter: "fab fa-twitter",
    whatsapp: "fab fa-whatsapp",
    youtube: "fab fa-youtube",
  },

  services: {
    aiDataOperations: "fas fa-briefcase",
    applicationDevelopment: "fas fa-laptop-code",
    digitalMarketing: "fas fa-chart-line",
    rcmServices: "fas fa-heartbeat",
    staffingService: "fas fa-users-gear",
    talentContinuityManagement: "fas fa-people-line",
  },

  industries: {
    banking: "fas fa-plane",
    ecommerce: "fas fa-shopping-cart",
    education: "fas fa-graduation-cap",
    finance: "fas fa-building",
    healthcare: "fas fa-hospital",
    manufacturing: "fas fa-industry",
  },

  about: {
    bestPractices: "fas fa-cog",
    collaboration: "fas fa-users",
    domainKnowledge: "fas fa-briefcase",
    excellence: "fas fa-star",
    innovation: "fas fa-lightbulb",
    integrity: "fas fa-handshake",
    mission: "fa-solid fa-location-crosshairs",
    roi: "fas fa-chart-line",
    teamMember: "fas fa-user",
    vision: "fas fa-eye",
  },

  rating: {
    star: "fas fa-star",
  },
};

export default icons;
